import { Icon, Row } from '@advanza/advanza_generic'
import React from 'react'
import PromosFilterContainer from '../../containers/PromosFilterContainer'
import Pagination from '../Pagination'
import SafeButton from '../ui/SafeButton'

class PromosFilter extends React.Component {
    constructor(props) {
        super(props)
        this.onPageChange = this.onPageChange.bind(this)
        this._changeFilter = this._changeFilter.bind(this)
        this.add = this.add.bind(this)
        this.deleteSelection = this.deleteSelection.bind(this)
    }

    _changeFilter(options) {
        const { changeFilter, filterId } = this.props
        changeFilter(filterId, options)
    }

    componentDidMount() {
        const { defaultOptions = {}, filter } = this.props
        if (!filter) {
            this._changeFilter(defaultOptions)
        }
    }

    componentDidUpdate(prevProps) {
        const prevFilter = prevProps.filter || {}
        const { filter = {} } = this.props
        const didInvalidate = !prevFilter.didInvalidate && filter.didInvalidate
        if (didInvalidate) {
            this._changeFilter({})
        }
    }

    onPageChange(page, invalidate = false) {
        this._changeFilter({ page, didInvalidate: invalidate })
    }

    add() {
        const { add, filter } = this.props
        add(
            {
                name: '',
                identifier: '',
                description: '',
                q_params: '',
                eligibility_rules: '',
                safeguard_rules: '',
            },
            filter ? filter.filterId : 'admin',
        )
    }

    deleteSelection() {
        const { filter, deleteSelection } = this.props
        return deleteSelection(filter.filterId)
    }

    render() {
        const { filter, count, compact } = this.props

        if (compact) {
            return null
        }

        const pageNr = filter ? filter.page || 0 : 0
        const selection = filter ? filter.selection : []
        const pageSize = filter ? filter.pageSize : 40

        return (
            <Row className="v-center between" nm>
                {selection && selection.length > 0 && (
                    <SafeButton
                        action={this.deleteSelection}
                        className="btn warning"
                        confirmMessage={`delete ${selection.length} promos`}
                        buttonText="delete"
                    />
                )}
                <div className="to-right">
                    <button onClick={this.add} className="plain c-blue">
                        <Icon>add</Icon> add promo
                    </button>
                    {count > pageSize && (
                        <Pagination
                            current={pageNr}
                            pageSize={pageSize}
                            count={count}
                            onPageChange={this.onPageChange}
                        />
                    )}
                </div>
            </Row>
        )
    }
}

export default PromosFilterContainer(PromosFilter)
